export default __webpack_public_path__ + "static/media/joystickMain.72514f7b.svg";